/*
 * @Author: 张锐
 * @Date: 2021-04-27 17:37:12
 * @LastEditTime: 2021-04-27 17:38:32
 * @Description: 文件格式类型
 */
export const ACCEPT_CONFIG = {
  video: ['.jpeg','.jpe', '.gif', '.mp4','.mov','.rm', '.rmvb', '.avi','.rar','.zip', '.7z','.xml','.dps'],
  image: ['.png', '.jpg', '.bmp', '.tiff', '.tif'],
  document: ['.ofd'],
  pdfcument: ['.pdf'],
  domCon: ['.txt', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.wps'],
  onlineRead: ['.ofd', '.pdf', '.doc', '.docx','.xls', '.xlsx','.ppt', '.pptx','.zip','.rar','.wps','.txt'], //在线阅读
  getAll () {
    return [...this.domCon, ...this.pdfcument]
  },
  getAllDomCon () {
    return [...this.document, ...this.pdfcument]
  },
  getImg () {
    return [...this.image]
  },
  getFp () {
    return [...this.domCon, ...this.document]
  },
  getOfd () {
    return [...this.document]
  },
  getOnlineReadType(){
    return [...this.onlineRead , ...this.image]
  },
  getVideo(){
    return [...this.video , ...this.image, ...this.document, ...this.pdfcument, ...this.domCon]
  },

}



// WEBPACK FOOTER //
// ./src/comm/utils/acceptFileType.js